import styled from "styled-components";

export const Wrapper = styled.div`
  width: 117px;
  height: 36px;
  margin-left: 505px;
  margin-top: 65px;
  @media (max-width: 1400px) {
    margin-left: 410px;
    margin-top: 30px;
  }
`;
